import { Box } from '@lego/klik-ui';
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import yaml from 'react-syntax-highlighter/dist/esm/languages/hljs/yaml';
import { githubGist } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import type { ApplicationVersionDetailedResponse } from '@/hooks/application_version';
import { TextHeader } from '../common';

SyntaxHighlighter.registerLanguage('yaml', yaml);

type Props = {
  applicationVersion: ApplicationVersionDetailedResponse;
};

export const ApplicationVersionContent = (props: Props) => {
  let composeText: string | null = null;
  if (props.applicationVersion.composeFileContents) {
    try {
      composeText = atob(props.applicationVersion.composeFileContents);
    } catch {
      composeText = null;
    }
  }

  return (
    <Box background="white" boxShadow={'md'} padding={6} rounded={'md'}>
      <TextHeader mb={3} tagLevel="h3" title="Docker Compose" />
      {composeText && (
        <Box background="slate.50" boxShadow="inner" px={4} py={2} rounded="md">
          <SyntaxHighlighter
            customStyle={{ background: 'transparent', margin: 0, padding: 0, fontSize: '14px' }}
            language="yaml"
            style={githubGist}
          >
            {composeText}
          </SyntaxHighlighter>
        </Box>
      )}
    </Box>
  );
};
